import { OnlineDemoPicturesStorage } from './OnlineDemoPicturesStorage';


export class CameraDemoPicsProvider
{
    public async Get(): Promise<string[]>
    {
        const storage = new OnlineDemoPicturesStorage();
        const pictures = await storage.GetFiles("tx-demo");

        const demoPics = pictures.map(x => x.Original);

        return demoPics;
    }
}
